import { Divider, Grid, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import YearType from '../../../Leave/views/YearType/YearType';
import { useTheme } from "@mui/material/styles";
import CompanyDetail from '../../../Ancillary/CompanyDetails/views/CompanyDetail';
import WeekOff from '../../../Leave/views/WeekOff/WeekOff';
import WorkingHours from '../../../Leave/views/WorkHours/WorkingHours';
import EmployeeID from '../Employee/EmployeeID';
import { getUserData } from '../../../Base/helper/baseFunctions';
import LetterHead from '../LetterHead/LetterHead';
import NoticePeriodConfig from '../../../Ancillary/NoticePeriod/views/NoticePeriodConfig';
import WorkLocation from '../../../Ancillary/WorkLocation/views/WorkLocation';
import CompanyBankDetails from '../../../Ancillary/CompanyDetails/views/CompanyBankDetails';
import CompanyRefNo from '../../../Ancillary/CompanyDetails/views/CompanyRefNo';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const Others = () => {
    const userData = getUserData();
    const theme = useTheme();
    const { leaveYearTypeData } = useSelector(state => state?.LeaveReducer?.LeaveYearTypeReducer);
    const { week_off_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
    const { work_hours_data } = useSelector(state => state.LeaveReducer?.WeekOffConfigureReducer);
   
    const values = [
        { name: "Employee ID Configuration", comp: <EmployeeID />, tooltip: "Configure separate Employee ID formats for Full-Time and Contractual employees. Each employee's ID will be generated based on the configuration for their employment type." },
        { name: "Company Logo", comp: <CompanyDetail /> },
        { name: "Company Bank Details", comp: <CompanyBankDetails />, tooltip: "Optional details of organization bank details" },
        { name: "Letter Head", comp: <LetterHead />, count: work_hours_data?.length || 0 },
        { name: "Business Year Type", comp: <YearType />, count: leaveYearTypeData?.length || 0 },
        { name: "Company Ref No.", comp: <CompanyRefNo /> }, // used in client invoice
        { name: "Notice Period", comp: <NoticePeriodConfig /> },
        { name: "Work Location", comp: <WorkLocation />, tooltip: "Configure work locations and geo-fencing coordinates used for employee attendance tracking." },
        // { name: "Projects", comp: <MyTime />, count: mytime_options?.length || 0 },
        { name: "Week Off Configuration", comp: <WeekOff />, count: week_off_data?.length || 0 },
        { name: "Working Hours", comp: <WorkingHours />, count: work_hours_data?.length || 0 },
        
    ];
    const filteredValues = values?.filter((value) => {
        if (userData?.f_country_code !== "IND") {
            return value.name !== "Business Year Type" &&
                value.name !== "Week Off Configuration"
        }
        return true; // Show all items if the country code is "IND"
    });
    return (
        <Grid container spacing={2} style={{ padding: "10px 0px" }}>
            {filteredValues?.map((value, id) => (
                <React.Fragment key={id}>
                    <Grid item xs={12} md={["Notice Period", "Business Year Type", "Company Ref No."].includes(value?.name) ? 6 : 12} key={id}>

                        <Typography
                            variant="h6"
                            gutterBottom
                            sx={{ paddingLeft: "15px", color: theme.palette.primary.contrastText,
                                fontWeight: 600,
                                display: "flex",
                                alignItems: "center",
                                mb: 2,
                                gap: 0.5
                             }}
                                           
                        >
                            {value?.name}
                            {value?.tooltip && <Tooltip title={value?.tooltip} arrow placement="bottom">
                                <InfoOutlinedIcon
                                color="action"
                                sx={{
                                    cursor: "pointer",
                                    fontSize: 16,
                                }}
                                />
                            </Tooltip>}
                        </Typography>
                        {value?.comp}

                    </Grid>
                    {([0, 1, 2, 3, 5, 6, 7, 8, 9, 10].includes(id)) && (
                        <Grid item xs={12}>
                            <Divider sx={{ my: 1 }} />
                        </Grid>
                    )}
                </React.Fragment>
            ))}
        </Grid>
    );
};

export default Others;
